// extracted by mini-css-extract-plugin
export var centerText = "_6e-8";
export var container = "_6e-0";
export var doughnutContainer = "_6e-7";
export var legend = "_6e-a";
export var legendItemColorDisplay = "_6e-b";
export var legendItemLabel = "_6e-d";
export var legendItemValue = "_6e-c";
export var lg = "_6e-5";
export var maxWidth = "_6e-9";
export var md = "_6e-4";
export var responsive = "_6e-6";
export var sm = "_6e-3";
export var xs = "_6e-2";
export var xxs = "_6e-1";